import type { StatusBadgeProps } from "@/components/ds/StatusBadge";
type Tone = NonNullable<StatusBadgeProps["tone"]>;

export const EST_STATUS: Record<string, { label: string; tone: Tone }> = {
  estimate_requested: { label: "Requested", tone: "slate" },
  estimate_sent: { label: "Sent", tone: "blue" },
  awaiting_decision: { label: "Awaiting Decision", tone: "amber" },
  accepted: { label: "Accepted", tone: "green" },
  declined: { label: "Declined", tone: "red" },
  expired: { label: "Expired", tone: "slate" },
  cancelled: { label: "Cancelled", tone: "slate" },
};

export const STATUS_OPTIONS = Object.entries(EST_STATUS).map(([value, m]) => ({ value, label: m.label }));

export const STEP_META: Record<string, { label: string; tone: Tone }> = {
  sent: { label: "Sent", tone: "green" },
  unavailable: { label: "Unavailable — Config Required", tone: "amber" },
  skipped: { label: "Skipped", tone: "slate" },
  pending: { label: "Scheduled", tone: "blue" },
};

export function amountText(amount: number | null, disclosed: boolean): string {
  if (!disclosed || amount === null || amount === undefined) return "Not disclosed";
  return `$${Number(amount).toLocaleString()}`;
}

export function fmtDate(iso?: string | null): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}
